import React, { useEffect, useState } from 'react'
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './home.css'
import dayjs from 'dayjs'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import { Box, Button, Menu } from '@mui/material';
import Carousel from 'react-multi-carousel'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Link, useNavigate } from 'react-router-dom'
import { airports, searchAirports } from '../../api/airport'
import { FormControl } from '@mui/material'
import { flightBooking } from '../../api/flight'
import { ToastContainer, toast } from 'react-toastify'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { packageCity, packageGet } from '../../api/package'
import { getImageUrl } from '../../utils/imageUrl'
// -------------------------------------------------


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const destination = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
}

const Home = () => {
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [value, setValue] = React.useState(0);
  const notify = (message) => toast(message)
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      setFlighDetails({
        journeyInfo: [{
          from: "",
          to: "",
          departureTime: '',

          departureDate: "",

        }],


        passengerCount: {
          adult: 0,
          infant: 0,
          child: 0
        },
        flightClass: "",
        type: "One Way" || "",
        flightType: '',
        specialFare: ''

      })
    } else if (newValue === 1) {

      setFlighDetails({
        journeyInfo: [{
          from: "",
          to: "",
          departureTime: '',
          returnTime: '',
          departureDate: "",
          returnDate: "",
        }],


        passengerCount: {
          adult: 0,
          infant: 0,
          child: 0
        },
        flightClass: "",
        type: "Round Trip",
        flightType: '',
        specialFare: ""

      })
    } else {
      setFlighDetails({
        journeyInfo: [{
          from: '',
          to: '',
          departureDate: ''
        }],



        passengerCount: {
          adult: 0,
          infant: 0,
          child: 0
        },
        flightClass: "",
        type: "Multi City",
        flightType: "",
        specialFare: ''

      })
    }
  };
  const [airport, setAirport] = useState([])
  const [airport1, setAirport1] = useState([])
  const getAirports = async (val) => {
    const resp = await searchAirports({ search: val })
    setAirport1(resp.data)
  }

  const getAirportSearch = async (val) => {
    const resp = await searchAirports({ search: val })
    setAirport(resp.data)
  }

  const [inputValue, setInputValue] = React.useState('');
  const [inputValue1, setInputValue1] = React.useState('');
  const [val, setVal] = useState([''])
  const [bal, setBal] = useState([''])
  const newFrom = airport?.map((items) => (
    { label: items.name + '(' + items.code + ')', value: items.name }))
  console.log(newFrom)
  useEffect(() => {
    if (inputValue1 !== null) {
      getAirports(inputValue1)
    } else {
      getAirports(null)
    }
  }, [inputValue1])

  useEffect(() => {
    if (inputValue !== null) {
      getAirportSearch(inputValue)
    } else {
      getAirportSearch(null)
    }
  }, [inputValue])

  const [flightDetails, setFlighDetails] = useState({
    journeyInfo: [{
      from: "",
      to: "",
      departureTime: '',

      departureDate: "",
    }],
    passengerCount: {
      adult: 0,
      infant: 0,
      child: 0
    },
    flightClass: "",
    type: "One Way" || "",
    flightType: "",
    specialFare: ''

  })

  useEffect(() => {
    if (value) {

      setAdultCount(0)
      setChildCount(0)
    }
  }, [value])

  const [childCount, setChildCount] = useState(0)

  const [adultCount, setAdultCount] = useState(0)

  const [infantCount, setInfantCount] = useState(0)


  useEffect(() => {
    if (adultCount === 0) {
      setFlighDetails({
        ...flightDetails,
        passengerCount: {
          ...flightDetails.passengerCount,
          adult: 0
        }
      })
    } else {

      setFlighDetails({
        ...flightDetails,
        passengerCount: {
          ...flightDetails.passengerCount,
          adult: adultCount
        }
      })
    }
  }, [adultCount])
  useEffect(() => {
    if (childCount === 0) {
      setFlighDetails({
        ...flightDetails,
        passengerCount: {
          ...flightDetails.passengerCount,
          child: 0
        }
      })
    } else {
      setFlighDetails({
        ...flightDetails,
        passengerCount: {
          ...flightDetails.passengerCount,
          child: childCount
        }
      })
    }
  }, [childCount])

  useEffect(() => {
    if (infantCount === 0) {
      setFlighDetails({
        ...flightDetails,
        passengerCount: {
          ...flightDetails.passengerCount,
          infant: 0
        }
      })
    } else {
      setFlighDetails({
        ...flightDetails,
        passengerCount: {
          ...flightDetails.passengerCount,
          infant: infantCount
        }
      })
    }
  }, [infantCount])

  const newTo = airport1?.filter((item) => {
    return item?.name !== flightDetails.journeyInfo[0]?.from
  }).map((items) => {
    return { label: items.name + '(' + items.code + ')', value: items.name }
  })


  // const newTo = to.slice(0, 500)
  function checkEmptyKeys(obj) {
    for (const key in obj) {
      if (obj[key] === "" || obj[key] === 0) {
        return true;
      }
    }
    return false;
  }
  const token = localStorage.getItem('token')
  console.log(checkEmptyKeys(flightDetails))
  const submit = async () => {
    if (token) {
      if (flightDetails.type === 'One Way') {

        if (flightDetails.flightClass === '') {
          notify('Flight Class is required')
        } else if (flightDetails?.flightType === '') {
          notify('Flight Type is required')
        } else if (flightDetails?.passengerCount?.adult === 0) {
          notify('Adult Count is required')
        } else if (flightDetails?.specialFare === '') {
          notify('Special fare is required')
        } else if (flightDetails?.type === '') {
          notify('Type is required')
        }
        else if (flightDetails.journeyInfo[0].from === '' || flightDetails.journeyInfo[0].to === '' || flightDetails.journeyInfo[0].departureDate === '' || flightDetails.journeyInfo[0].departureTime === '') {
          notify('Journey details are missing')
        } else {
          try {
            const resp = await flightBooking(flightDetails)
            if (resp.code === 201) {
              notify(resp.message)
              handleChange(null, 0)
              setTimeout(() => {
                window.location.reload()
              }, 3000);
              setFlighDetails({
                journeyInfo: [{
                  from: "",
                  to: "",
                  departureTime: '',

                  departureDate: "",

                }],


                passengerCount: {
                  adult: 0,
                  infant: 0,
                  child: 0
                },
                flightClass: "",
                type: "One Way" || "",
                flightType: '',
                specialFare: ''

              })
            } else {
              notify(resp.message)
              handleChange(null, 0)
            }
          } catch (error) {
            notify(error.message)
            handleChange(null, 0)
          }


        }
      } else if (flightDetails.type === 'Round Trip') {
        if (flightDetails.flightClass === '') {
          notify('Flight Class is required')
        } else if (flightDetails?.flightType === '') {
          notify('Flight Type is required')
        } else if (flightDetails?.passengerCount?.adult === 0) {
          notify('Adult Count is required')
        } else if (flightDetails?.specialFare === '') {
          notify('Special fare is required')
        } else if (flightDetails?.type === '') {
          notify('Type is required')
        } else if (flightDetails.journeyInfo[0].from === '' || flightDetails.journeyInfo[0].to === '' || flightDetails.journeyInfo[0].departureDate === '' || flightDetails.journeyInfo[0].departureTime === '' || flightDetails.journeyInfo[0].returnDate === '' || flightDetails.journeyInfo[0].returnTime === '') {
          notify('Journey details are missing')
        } else {

          try {
            const resp = await flightBooking(flightDetails)
            if (resp.code === 201) {
              notify(resp.message)
              handleChange(null, 0)
              setTimeout(() => {
                window.location.reload()
              }, 3000);

              setFlighDetails({
                journeyInfo: [{
                  from: "",
                  to: "",
                  departureTime: '',

                  departureDate: "",

                }],


                passengerCount: {
                  adult: 0,
                  infant: 0,
                  child: 0
                },
                flightClass: "",
                type: "One Way" || "",
                flightType: '',
                specialFare: ''

              })
            } else {
              notify(resp.message)
              handleChange(null, 0)
            }
          } catch (error) {
            notify(error.message)
            handleChange(null, 0)
          }


        }
      } else {
        if (flightDetails.flightClass === '') {
          notify('Flight Class is required')
        } else if (flightDetails?.flightType === '') {
          notify('Flight Type is required')
        } else if (flightDetails?.passengerCount?.adult === 0) {
          notify('Adult Count is required')
        } else if (flightDetails?.specialFare === '') {
          notify('Special fare is required')
        } else if (flightDetails?.type === '') {
          notify('Type is required')
        } else {
          if (flightDetails.journeyInfo[0].from === '' || flightDetails.journeyInfo[0].to === '' || flightDetails.journeyInfo[0].departureDate === '' || flightDetails.journeyInfo[0].departureTime === '' || flightDetails.journeyInfo[0].returnDate === '' || flightDetails.journeyInfo[0].returnTime === '') {
            notify('Journey details are missing')
          } else {
            try {
              const resp = await flightBooking(flightDetails)
              if (resp.code === 201) {
                notify(resp.message)
                handleChange(null, 0)
                setTimeout(() => {
                  window.location.reload()
                }, 3000);


                setFlighDetails({
                  journeyInfo: [{
                    from: "",
                    to: "",
                    departureTime: '',

                    departureDate: "",

                  }],


                  passengerCount: {
                    adult: 0,
                    infant: 0,
                    child: 0
                  },
                  flightClass: "",
                  type: "One Way" || "",
                  flightType: '',
                  specialFare: ''

                })
              } else {
                notify(resp.message)
                handleChange(null, 0)
              }
            } catch (error) {
              notify(error.message)
              handleChange(null, 0)
            }
          }



        }
      }
    } else {
      notify('Please Login for booking')
    }


  }

  const today = dayjs();
  const tomorrow = dayjs()
  const [active, setActive] = useState('')
  const [activeReturn, setActiveReturn] = useState('')
  const [activeDep, setActiveDep] = useState('')
  const [fromDate, setFromDate] = useState('')

  const [tourDetail, setTourDetail] = useState({
    city: '',
    type: ''
  })

  const [tourData, setTourData] = useState([])
  const [tourInternationalData, setTourInternationalData] = useState([])
  const [tourCorporateData, setTourCorporateData] = useState([])
  const getPackages = async () => {
    if (tourDetail.type === '') {
      alert('Please fill type')
    } else if (tourDetail.city === '') {
      alert('Please fill City')
    } else {
      const resp = await packageGet(tourDetail)
      const filterInterNational = resp.data?.filter((item) => {
        return item?.packageMode === 'International'
      })
      const national = resp.data?.filter((item) => {
        return item?.packageMode === 'National'
      })
      const corporate = resp.data?.filter((item) => {
        return item?.packageMode === 'Corporate'
      })
      setTourInternationalData(filterInterNational)
      setTourData(national)
      setTourCorporateData(corporate)
    }
  }


  const getPackage = async () => {
    const resp = await packageGet()
    const filterInterNational = resp.data?.filter((item) => {
      return item?.packageMode === 'International'
    })
    const national = resp.data?.filter((item) => {
      return item?.packageMode === 'National'
    })
    const corporate = resp.data?.filter((item) => {
      return item?.packageMode === 'Corporate'
    })
    setTourInternationalData(filterInterNational)
    setTourData(national)
    setTourCorporateData(corporate)
  }

  useEffect(() => {
    getPackage()
  }, [])

  return (
    <>
      <Header />
      <section className=''>
        <div className='container'>
          <div className="mainBannerSection">
            <div className="row">
              <div className="col-md-10 mx-auto text-center">
                <h1 className="text-dark display-3 pt-sm-5 my-5">Ready to take off?</h1>
              </div>
            </div>
            <Box
              sx={{
                width: '100%',
                backgroundColor: '#fff',
                borderRadius: '10px',
              }}>
              <Box
                className="tabSection"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '10px 15px 0px 15px',
                }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label="One Way" {...a11yProps(0)} />
                  <Tab label="Round Trip" {...a11yProps(1)} />
                  <Tab label="Multi City" {...a11yProps(2)} />
                </Tabs>
                <div className='selectSection'>
                  {/* <FormControl
                    className='w-1'
                    sx={{ width: '30%' }}
                  >
                    <InputLabel size='small' id="demo-simple-select-label">Special fare</InputLabel>
                    <Select
                      size='small'
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Special fare"
                    >
                      <MenuItem value={''}>Special fare</MenuItem>
                      <MenuItem value={'regular'}>Regular</MenuItem>
                      <MenuItem value={'student'}>Student</MenuItem>
                      <MenuItem value={'seniorCitizen'}>Senior Citizen</MenuItem>
                      <MenuItem value={'armedForces'}>Armed Forces</MenuItem>
                      <MenuItem value={'doctorAndNurses'}>Doctor and Nurses</MenuItem>
                    </Select>
                  </FormControl> */}
                  <Autocomplete
                    className='w-1'
                    sx={{ width: '45%', ml: 2 }}
                    size='small'
                    disablePortal
                    id="combo-box-demo"
                    value={flightDetails.flightClass}
                    options={classes}
                    onChange={(e, newValue) => {
                      if (newValue !== null) {
                        setFlighDetails({
                          ...flightDetails,
                          flightClass: newValue.value
                        })
                      } else {
                        return;
                      }


                    }}
                    renderInput={(params) => <TextField {...params} label="Select Class" />}
                  />



                  <div className='guestBox'>
                    <Button
                      id="basic-button"
                      aria-controls={open ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      onClick={handleClick}
                      className='guestBtn'
                    >
                      {flightDetails.passengerCount.adult > 0 && `Adult Count ${flightDetails.passengerCount.adult}`} {' '}
                      {flightDetails.passengerCount.child > 0 && `Child Count ${flightDetails.passengerCount.child}`}
                      {flightDetails.passengerCount.adult === 0 && flightDetails.passengerCount.child === 0 && `Passenger Count`}

                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      <MenuItem className='muiB'>
                        <ul class="dropdown-menu guest-selector-dropdown show" style={{ position: 'absolute', inset: '0px auto auto 0px', margin: '0px', }} data-popper-placement="bottom-start">
                          <li class="d-flex justify-content-between">
                            <div>
                              <h6 class="mb-0">Adults</h6>
                              <small>Ages 13 or above</small>
                            </div>
                            <div class="hstack gap-1 align-items-center">
                              <button
                                onClick={() => {
                                  if (adultCount > 0) {
                                    setAdultCount(adultCount - 1)
                                  } else {
                                    setFlighDetails({
                                      ...flightDetails,
                                      passengerCount: {
                                        ...flightDetails.passengerCount,
                                        adult: 0
                                      }
                                    })
                                  }
                                }}
                                class="btn btn-md btn-link adult-remove p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                </svg>
                              </button>
                              <h6 class="guest-selector-count mb-0 adults">{adultCount}</h6>
                              <button
                                onClick={() => {

                                  setAdultCount(adultCount + 1)

                                }}
                                class="btn btn-md btn-link adult-add p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                </svg>
                              </button>
                            </div>
                          </li>
                          <li class="dropdown-divider"></li>
                          <li class="d-flex justify-content-between">
                            <div>
                              <h6 class="mb-0">Child</h6>
                              <small>Ages 13 below</small>
                            </div>
                            <div class="hstack gap-1 align-items-center">
                              <button
                                onClick={() => {
                                  if (childCount > 0) {
                                    setChildCount(childCount - 1)
                                  } else {
                                    setFlighDetails({
                                      ...flightDetails,
                                      passengerCount: {
                                        ...flightDetails.passengerCount,
                                        child: adultCount
                                      }
                                    })
                                  }
                                }}
                                class="btn btn-md btn-link adult-remove p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                </svg>
                              </button>
                              <h6 class="guest-selector-count mb-0 child">{childCount}</h6>
                              <button
                                onClick={() => {

                                  setChildCount(childCount + 1)

                                }}
                                class="btn btn-md btn-link adult-add p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                </svg>
                              </button>
                            </div>
                          </li>
                          <li class="dropdown-divider"></li>
                          <li class="d-flex justify-content-between">
                            <div>
                              <h6 class="mb-0">Infant</h6>
                              {/* <small>Max room 8</small> */}
                            </div>
                            <div class="hstack gap-1 align-items-center">
                              <button
                                onClick={() => {
                                  if (infantCount > 0) {
                                    setInfantCount(infantCount - 1)
                                  } else {
                                    setFlighDetails({
                                      ...flightDetails,
                                      passengerCount: {
                                        ...flightDetails.passengerCount,
                                        infant: 0
                                      }
                                    })
                                  }
                                }}
                                class="btn btn-md btn-link adult-remove p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                </svg>
                              </button>
                              <h6 class="guest-selector-count mb-0 rooms">{infantCount}</h6>
                              <button
                                onClick={() => {
                                  setInfantCount(infantCount + 1)
                                }}
                                class="btn btn-md btn-link adult-add p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                </svg>
                              </button>
                            </div>
                          </li>
                        </ul>
                      </MenuItem>
                    </Menu>
                  </div>

                </div>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <div className='row'>
                  <div className='col-md-6 col-lg-3'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-location-dot"></i> From</label>
                      <Autocomplete
                        size='small'
                        sx={{ mt: 1 }}
                        disablePortal
                        id="combo-box-demo"
                        options={newFrom}
                        getOptionLabel={(option) => {
                          if (option.label) {
                            return option.label
                          } else if (typeof option === 'string') {
                            return option
                          } else {
                            return ""
                          }
                        }
                        }
                        isOptionEqualToValue={(option, value) => {
                          if (option.value && value.value) { return option.value === value.value } else {
                            return false
                          }
                        }}
                        value={flightDetails?.journeyInfo[0]?.from}
                        onChange={(e, newValue) => {

                          if (newValue !== null) {
                            const tempData = flightDetails
                            tempData.journeyInfo[0].from = newValue.value
                            setFlighDetails(tempData)
                          } else {
                            return;
                          }

                        }}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                          if (newInputValue !== null) {
                            setInputValue(newInputValue);
                          } else {
                            return;
                          }



                        }}
                        renderInput={(params) => <TextField  {...params} label="Select Location" />}
                      />
                    </div>
                  </div>
                  <div className='col-md-6 col-lg-3'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-location-arrow"></i> To</label>
                      <Autocomplete
                        size='small'
                        sx={{ mt: 1 }}
                        disablePortal
                        id="combo-box-demo"
                        options={newTo}
                        getOptionLabel={(option) => {
                          if (option.label) {
                            return option.label
                          } else if (typeof option === 'string') {
                            return option
                          } else {
                            return ""
                          }
                        }
                        }
                        isOptionEqualToValue={(option, value) => {
                          if (option.value && value.value) { return option.value === value.value } else {
                            return false
                          }
                        }}
                        value={flightDetails.to}
                        onChange={(e, newValue) => {
                          if (newValue !== null) {
                            const tempData = flightDetails
                            tempData.journeyInfo[0].to = newValue?.value
                            setFlighDetails(tempData)
                          } else {
                            return;
                          }

                        }}
                        // getOptionLabel={(option) => (option.label ? option.label : '')}
                        inputValue={inputValue1}
                        onInputChange={(event, newInputValue) => {
                          if (newInputValue !== null) {
                            setInputValue1(newInputValue);
                          } else {
                            return;
                          }

                        }}
                        renderInput={(params) => <TextField {...params} label="Select Location" />}
                      />
                    </div>
                  </div>
                  <div className='col-md-6 col-lg-3 dateCol'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-calendar"></i> Departure Time</label>
                      <div className="timeSlotsOuter">
                        <div
                          onClick={() => {


                            const tempData = flightDetails
                            tempData.journeyInfo[0].departureTime = 'before 6 AM'
                            setFlighDetails(tempData)
                            setActive('before 6 AM')
                          }}
                          className={active === 'before 6 AM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>
                          <img className="checkBlockIcon" src='images/morning_inactive.webp' alt='' />
                          <div className="boldFont">Before <b>6</b> AM</div>
                        </div>
                        <div
                          onClick={() => {

                            const tempData = flightDetails
                            tempData.journeyInfo[0].departureTime = '6 AM - 12 PM'
                            setFlighDetails(tempData)
                            setActive('6 AM - 12 PM')

                          }}
                          className={active === '6 AM - 12 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/noon_inactive.webp' alt='' />
                          <div className="boldFont"><b>6</b> AM - <b>12</b> PM</div>
                        </div>
                        <div
                          onClick={() => {
                            const tempData = flightDetails
                            tempData.journeyInfo[0].departureTime = '12 PM - 6 PM'
                            setFlighDetails(tempData)
                            setActive('12 PM - 6 PM')
                          }}
                          className={active === '12 PM - 6 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/evening_inactive.webp' alt='' />
                          <div className="boldFont"><b>12</b> PM - <b>6</b> PM</div>
                        </div>
                        <div
                          onClick={() => {
                            const tempData = flightDetails
                            tempData.journeyInfo[0].departureTime = 'after 6 PM'
                            setFlighDetails(tempData)
                            setActive('after 6 PM')
                          }}
                          className={active === 'after 6 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/night_inactive.webp' alt='' />
                          <div className="boldFont">After <br /><b>6</b> PM</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6 col-lg-3 dateCol'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3 daeSection'>
                      <label className="mb-1"><i className="fa-solid fa-calendar"></i> Departure</label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            label="Select Date"

                            minDate={tomorrow}
                            slotProps={{ textField: { size: 'small' } }}
                            value={flightDetails.journeyInfo[0].departureDate}
                            onChange={(newValue) => {
                              const date = new Date(newValue['$d']);

                              const tempData = flightDetails
                              tempData.journeyInfo[0].departureDate = date
                              setFlighDetails(tempData)



                            }}

                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <div className='row'>
                  <div className='col-md-6 col-lg-4 py-1'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-location-dot"></i> From</label>
                      <Autocomplete
                        size='small'
                        sx={{ mt: 1 }}
                        disablePortal
                        id="combo-box-demo"
                        options={newFrom}
                        getOptionLabel={(option) => {
                          if (option.label) {
                            return option.label
                          } else if (typeof option === 'string') {
                            return option
                          } else {
                            return ""
                          }
                        }
                        }
                        isOptionEqualToValue={(option, value) => {
                          if (option.value && value.value) { return option.value === value.value } else {
                            return false
                          }
                        }}
                        value={flightDetails.from}
                        // getOptionLabel={(option) => (option.label ? option.label : '')}
                        onChange={(e, newValue) => {
                          if (newValue !== null) {
                            const tempData = flightDetails
                            tempData.journeyInfo[0].from = newValue.value
                            setFlighDetails(tempData)
                          } else {
                            return;
                          }

                        }}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                          if (newInputValue !== null) {
                            setInputValue(newInputValue);
                          } else {
                            return;
                          }

                        }}
                        renderInput={(params) => <TextField {...params} label="Select Location" />}
                      />
                    </div>
                  </div>
                  <div className='col-md-6 col-lg-4 py-1'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-location-arrow"></i> To</label>
                      <Autocomplete
                        size='small'
                        sx={{ mt: 1 }}
                        disablePortal
                        id="combo-box-demo"
                        options={newTo}
                        getOptionLabel={(option) => {
                          if (option.label) {
                            return option.label
                          } else if (typeof option === 'string') {
                            return option
                          } else {
                            return ""
                          }
                        }
                        }
                        isOptionEqualToValue={(option, value) => {
                          if (option.value && value.value) { return option.value === value.value } else {
                            return false
                          }
                        }}
                        value={flightDetails.to}
                        // getOptionLabel={(option) => (option.label ? option.label : '')}
                        onChange={(e, newValue) => {
                          if (newValue !== null) {
                            const tempData = flightDetails
                            tempData.journeyInfo[0].to = newValue.value
                            setFlighDetails(tempData)
                          } else {
                            return
                          }

                        }}
                        inputValue={inputValue1}
                        onInputChange={(event, newInputValue) => {
                          if (newInputValue !== null) {
                            setInputValue1(newInputValue);
                          } else {
                            return;
                          }

                        }}
                        renderInput={(params) => <TextField {...params} label="Select Location" />}
                      />
                    </div>
                  </div>
                  <div className='col-md-6 col-lg-4 dateCol py-1'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-calendar"></i> Departure Time</label>
                      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['TimePicker']}>
                          <TimePicker
                            slotProps={{ textField: { size: 'small' } }}
                            label="Time"
                            viewRenderers={{
                              hours: renderTimeViewClock,
                              minutes: renderTimeViewClock,
                              seconds: renderTimeViewClock,
                            }}
                            value={flightDetails.departureTime}
                            onChange={(newValue) => {

                              console.log(newValue)
                              const date = new Date(newValue['$d']);

                              setFlighDetails({
                                ...flightDetails,
                                departureTime: new Date(date).getTime()
                              })


                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider> */}
                      <div className="timeSlotsOuter">
                        <div
                          onClick={() => {
                            const tempData = flightDetails
                            tempData.journeyInfo[0].departureTime = 'before 6 AM'
                            setFlighDetails(tempData)
                            setActiveDep('before 6 AM')
                          }}
                          className={activeDep === 'before 6 AM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/morning_inactive.webp' alt='' />
                          <div className="boldFont">Before <b>6</b> AM</div>
                        </div>
                        <div
                          onClick={() => {


                            const tempData = flightDetails
                            tempData.journeyInfo[0].departureTime = '6 AM - 12 PM'
                            setFlighDetails(tempData)
                            setActiveDep('6 AM - 12 PM')
                          }}
                          className={activeDep === '6 AM - 12 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/noon_inactive.webp' alt='' />
                          <div className="boldFont"><b>6</b> AM - <b>12</b> PM</div>
                        </div>
                        <div
                          onClick={() => {


                            const tempData = flightDetails
                            tempData.journeyInfo[0].departureTime = '2 PM - 6 PM'
                            setFlighDetails(tempData)
                            setActiveDep('2 PM - 6 PM')
                          }}
                          className={activeDep === '2 PM - 6 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/evening_inactive.webp' alt='' />
                          <div className="boldFont"><b>12</b> PM - <b>6</b> PM</div>
                        </div>
                        <div
                          onClick={() => {

                            const tempData = flightDetails
                            tempData.journeyInfo[0].departureTime = 'after 6 PM'
                            setFlighDetails(tempData)
                            setActiveDep('after 6 PM')

                          }}
                          className={activeDep === 'after 6 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/night_inactive.webp' alt='' />
                          <div className="boldFont">After <b>6</b> PM</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6 col-lg-4 dateCol py-1'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-calendar"></i> Departure Date</label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            label="Select Date"

                            minDate={tomorrow}
                            slotProps={{ textField: { size: 'small' } }}
                            value={flightDetails.journeyInfo[0].departureDate}
                            onChange={(newValue) => {
                              const date = new Date(newValue['$d']);
                              setFromDate(date)
                              const tempData = flightDetails
                              tempData.journeyInfo[0].departureDate = date
                              setFlighDetails(tempData)
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className='col-md-6 col-lg-4 dateCol py-1'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-calendar"></i> Return Time</label>

                      <div className="timeSlotsOuter">
                        <div
                          onClick={() => {
                            const tempData = flightDetails
                            tempData.journeyInfo[0].returnTime = 'before 6 AM'
                            setFlighDetails(tempData)
                            setActiveReturn('before 6 AM')
                          }}
                          className={activeReturn === 'before 6 AM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/morning_inactive.webp' alt='' />
                          <div className="boldFont">Before <b>6</b> AM</div>
                        </div>
                        <div
                          onClick={() => {


                            const tempData = flightDetails
                            tempData.journeyInfo[0].returnTime = '6 AM - 12 PM'
                            setFlighDetails(tempData)
                            setActiveReturn('6 AM - 12 PM')
                          }}
                          className={activeReturn === '6 AM - 12 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/noon_inactive.webp' alt='' />
                          <div className="boldFont"><b>6</b> AM - <b>12</b> PM</div>
                        </div>
                        <div
                          onClick={() => {


                            const tempData = flightDetails
                            tempData.journeyInfo[0].returnTime = '12 PM - 6 PM'
                            setFlighDetails(tempData)
                            setActiveReturn('12 PM - 6 PM')
                          }}
                          className={activeReturn === '12 PM - 6 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/evening_inactive.webp' alt='' />
                          <div className="boldFont"><b>12</b> PM - <b>6</b> PM</div>
                        </div>
                        <div
                          onClick={() => {

                            const tempData = flightDetails
                            tempData.journeyInfo[0].returnTime = 'after 6 PM'
                            setFlighDetails(tempData)
                            setActiveReturn('after 6 PM')

                          }}
                          className={activeReturn === 'after 6 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/night_inactive.webp' alt='' />
                          <div className="boldFont">After <b>6</b> PM</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6 col-lg-4 dateCol py-1'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-calendar"></i> Return Date</label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker

                            minDate={dayjs(fromDate)}
                            label="Select Date"
                            slotProps={{ textField: { size: 'small' } }}
                            value={flightDetails.journeyInfo[0].returnDate}
                            onChange={(newValue) => {
                              const date = new Date(newValue['$d']);

                              const tempData = flightDetails
                              tempData.journeyInfo[0].returnDate = date
                              setFlighDetails(tempData)
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={2}>
                <div className='row mb-2'>
                  <div className='col-md-6 col-lg-3'>
                    {(flightDetails.journeyInfo?.length <= 2) && <button
                      style={{ fontSize: '12px' }}
                      className="btn btn-dark"
                      onClick={() => {
                        const tempData = flightDetails
                        tempData.journeyInfo.push({
                          from: '',
                          to: '',
                          departureDate: ''
                        })
                        setTimeout(() => {
                          setFlighDetails({
                            ...flightDetails,
                            journeyInfo: tempData.journeyInfo
                          })
                        }, 500)

                      }}
                    >
                      Add Another City
                    </button>}
                  </div>
                </div>
                {flightDetails?.journeyInfo?.map((items, index) => (
                  <div key={index} className='row mb-2'>
                    <div className='col-md-6 col-lg-4'>
                      <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                        <label className="mb-1"><i className="fa-solid fa-location-dot"></i> From</label>
                        <Autocomplete
                          size='small'
                          sx={{ mt: 1 }}
                          disablePortal
                          id="combo-box-demo"
                          options={newFrom}
                          getOptionLabel={(option) => {
                            if (option.label) {
                              return option.label
                            } else if (typeof option === 'string') {
                              return option
                            } else {
                              return ""
                            }
                          }
                          }
                          isOptionEqualToValue={(option, value) => {
                            if (option.value && value.value) { return option.value === value.value } else {
                              return false
                            }
                          }}
                          // getOptionLabel={(option) => (option.label ? option.label : '')}
                          value={flightDetails?.journeyInfo[index].from}
                          onChange={(e, newValue) => {
                            if (newValue !== null) {
                              const tempData = flightDetails
                              tempData.journeyInfo[index].from = newValue.value
                              setFlighDetails(tempData)
                            } else {
                              return;
                            }

                          }}
                          // inputValue={val[index]}
                          onInputChange={(event, newInputValue) => {
                            if (newInputValue !== null) {
                              getAirportSearch(newInputValue)
                            } else {
                              return;
                            }

                          }}
                          renderInput={(params) => <TextField {...params} label="Select Location" />}
                        />
                      </div>
                    </div>
                    <div className='col-md-6 col-lg-4'>
                      <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                        <label className="mb-1"><i className="fa-solid fa-location-arrow"></i> To</label>
                        <Autocomplete
                          size='small'
                          sx={{ mt: 1 }}
                          disablePortal
                          // getOptionLabel={(option) => (option.label ? option.label : '')}
                          id="combo-box-demo"
                          options={newTo}
                          getOptionLabel={(option) => {
                            if (option.label) {
                              return option.label
                            } else if (typeof option === 'string') {
                              return option
                            } else {
                              return ""
                            }
                          }
                          }
                          isOptionEqualToValue={(option, value) => {
                            if (option.value && value.value) { return option.value === value.value } else {
                              return false
                            }
                          }}
                          value={flightDetails?.journeyInfo[index].to}
                          onChange={(e, newValue) => {
                            if (newValue !== null) {
                              const tempData = flightDetails
                              tempData.journeyInfo[index].to = newValue.value
                              setFlighDetails(tempData)
                            } else {
                              return;
                            }

                          }}
                          onInputChange={(event, newInputValue) => {
                            if (newInputValue !== null) {
                              getAirports(newInputValue)
                            } else {
                              return;
                            }
                          }}
                          renderInput={(params) => <TextField {...params} label="Select Location" />}
                        />
                      </div>
                    </div>
                    <div className='col-md-6 col-lg-4 dateCol'>
                      <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3 daeSection'>
                        <label className="mb-1"><i className="fa-solid fa-calendar"></i> Departure Date</label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={['DatePicker']}>
                            <DatePicker

                              minDate={tomorrow}
                              label="Select Date"
                              slotProps={{ textField: { size: 'small' } }}
                              value={flightDetails?.journeyInfo[index].departureDate}
                              onChange={(newValue) => {
                                const date = new Date(newValue['$d']);
                                const tempData = flightDetails
                                tempData.journeyInfo[index].departureDate = date
                                setFlighDetails(tempData)

                              }}

                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </div>
                    </div>
                    {/* <div className='col-md-6 col-lg-3'>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between'
                        }}
                      >

                        <button
                          style={{ fontSize: '12px' }}
                          className="btn btn-dark mb-n4"
                          onClick={() => {
                            const tempData = flightDetails
                            // tempData.journeyInfo.splice(index, 1)
                            const newTemp = tempData.journeyInfo.filter((items, index2) => {
                              return index2 !== index
                            })
                            console.log(newTemp)
                            setTimeout(() => {
                              setFlighDetails({
                                ...flightDetails,
                                journeyInfo: newTemp
                              })
                            }, 500)
                          }}
                        >
                          Remove
                        </button>
                      </Box>



                    </div> */}

                  </div>
                ))}
              </CustomTabPanel>
              <Box
                sx={{
                  padding: '0px 25px 25px 25px',
                }}
              >
                <FormControl className='specialFare'>
                  <Box sx={{ mr: 3, width: '10%' }} className="wid">
                    <FormLabel className='labelFare'>Special fare</FormLabel>
                    {/* <div class="titleTag " style={{ backgroundImage: 'linear-gradient(to right, rgb(67, 225, 168), rgb(33, 147, 147))' }}>
                      <span class="dtTag">EXTRA SAVINGS</span>
                    </div> */}
                  </Box>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                    className='fareCol'
                  >
                    <FormControlLabel className='FareBox' value="regular" control={<Radio
                      value={'Regular'}

                      onChange={(e) => {
                        setFlighDetails({
                          ...flightDetails,
                          specialFare: e.target.value
                        })
                      }}
                    />} label="Regular" />
                    <FormControlLabel className='FareBox' value="student" control={<Radio
                      value={'Student'}

                      onChange={(e) => {
                        setFlighDetails({
                          ...flightDetails,
                          specialFare: e.target.value
                        })
                      }}
                    />} label="Student" />
                    <FormControlLabel className='FareBox' value="seniorCitizen" control={<Radio
                      value={'Senior Citizen'}

                      onChange={(e) => {
                        setFlighDetails({
                          ...flightDetails,
                          specialFare: e.target.value
                        })
                      }}
                    />} label="Senior Citizen" />
                    <FormControlLabel className='FareBox' value="armedForces" control={<Radio
                      value={'Armed Forces'}

                      onChange={(e) => {
                        setFlighDetails({
                          ...flightDetails,
                          specialFare: e.target.value
                        })
                      }}
                    />} label="Armed Forces" />
                    <FormControlLabel className='FareBox' value="doctorAndNurses" control={<Radio
                      value={'Doctor and Nurses'}

                      onChange={(e) => {
                        setFlighDetails({
                          ...flightDetails,
                          specialFare: e.target.value
                        })
                      }}
                    />} label="Doctor and Nurses" />
                  </RadioGroup>
                  <Autocomplete
                    className='w-1'
                    sx={{ width: '20%', mx: 2 }}
                    size='small'
                    disablePortal
                    // getOptionLabel={(option) => (option.label ? option.label : '')}
                    id="combo-box-demo"
                    value={flightDetails.flightType}
                    options={flightTypes}
                    onChange={(e, newValue) => {
                      setFlighDetails({
                        ...flightDetails,
                        flightType: newValue.value
                      })
                    }}
                    renderInput={(params) => <TextField {...params} label="Select Flight Type" />}
                  />
                </FormControl>
                <div className="col-12 text-end">
                  <button
                    onClick={submit}
                    className="btn btn-primary mb-n4" >
                    Book Now <i className="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              </Box>
            </Box>
          </div>
        </div>
      </section>
      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-9">
              <h4 className="mb-0 title">International Packages</h4>
            </div>
            <div className="col-3 text-end">
              <Link to="/tours/International" className="btn btn-lg btn-dark mb-0">View All</Link>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              {tourInternationalData?.map((items) => (
                <div onClick={() => {
                  navigate(`/tourDetail/${items?._id}`)
                }}

                  key={items?._id} className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src={getImageUrl(items?.images[0])} alt='' />
                    {/* <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6> */}
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">{items?.city} </a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">₹ {items?.price}</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              ))}
              {/* <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div> */}
            </Carousel>
          </div >
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-9">
              <h4 className="mb-0 title">Corporate Packages</h4>
            </div>
            <div className="col-3 text-end">
              <Link to="/tours/Corporate" className="btn btn-lg btn-dark mb-0">View All</Link>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              {tourCorporateData?.map((items) => (
                <div onClick={() => {
                  navigate(`/tourDetail/${items?._id}`)
                }}

                  key={items?._id} className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src={getImageUrl(items?.images?.[0])} alt='' />
                    {/* <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6> */}
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">{items?.city}</a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">₹ {items?.price}</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          </div >
        </div >
      </section >

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-9">
              <h4 className="mb-0 title">Domestic Packages</h4>
            </div>
            <div className="col-3 text-end">
              <Link to="/tours/Domestic" className="btn btn-lg btn-dark mb-0">View All</Link>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              {tourData?.map((items) => (
                <div onClick={() => {
                  navigate(`/tourDetail/${items?._id}`)
                }}

                  key={items?._id} className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src={getImageUrl(items?.images?.[0])} alt='' />
                    {/* <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6> */}
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">{items?.city} , India</a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">₹ {items?.price}</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              ))}
              {/* <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div> */}
            </Carousel>
          </div >
        </div >
      </section >

      <section className='specialOffers'>
        <div className='container'>
          <div className="bg-light rounded-3 position-relative p-4 p-sm-5">
            <div className="row align-items-center position-relative dicoverSec">
              <div className="col-lg-8">
                <div className="d-flex">
                  <h3>It's time to discover</h3>
                  <img src="images/04-DrYI6v5l.svg" className="h-40px ms-3" alt="" />
                </div>
                <p className="mb-3 mb-lg-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.  </p>
              </div>
              <div className="col-lg-4 text-lg-end"><Link to="/tour" className="btn btn-lg btn-dark mb-0">Book Now</Link></div>
            </div>
          </div>
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Top Categories</h4>
            </div>
          </div>
          <div className="row g-4 g-xl-5 topCate">
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Adventure`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/19-BYcWTs_B.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Adventure</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/SoundScape`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/13-CeWMv36_.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Sound Scape</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Desert`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/18-C_X3yjnw.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Desert</a></h5>
                    {/* <span>1587 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Pilgrims`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/19-BYcWTs_B.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Pilgrims</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/History`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/17-E7K6iGPB.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">History</a></h5>
                    {/* <span>986 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/IslandHopper`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/14-fpi-ZIwa.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">IslandHopper</a></h5>
                    {/* <span>786 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/General`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/16-D1cIRfhu.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">General</a></h5>
                    {/* <span>786 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Haunted`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/15-CGaqJfSo.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Haunted</a></h5>
                    {/* <span>568 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/14-fpi-ZIwa.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Temple</a></h5>
                    <span>256 Places</span>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/13-CeWMv36_.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Festival</a></h5>
                    <span>654 Places</span>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      {/* <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Special Offers</h4>
            </div>
          </div>
          <div className="row g-4 offersCard">
            <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="card bg-success bg-opacity-10 h-100 p-4">
                <img src="images/07-CimiEFYE.svg" className="w-75" alt="" />
                <div className="card-body mt-4 p-0">
                  <span className="mb-1">Flat</span>
                  <h4 className="mb-1">$899</h4>
                  <h6 className="fw-normal">On Domestic Flights</h6>
                  <div className="d-flex justify-content-between align-items-center mt-4">
                    <div className="bg-primary bg-opacity-10 border border-2 border-primary border-dashed rounded-2 px-3 py-2">
                      <h5 className="fw-normal user-select-all mb-0">8B99OFF</h5>
                    </div>
                    <a aria-current="page" href="#!" className="router-link-active router-link-exact-active btn btn-lg btn-white btn-round mb-0">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="mb-1">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="card bg-danger bg-opacity-10 h-100 p-4">
                <img src="images/08-O9kcayv8.svg" className="w-75" alt="" />
                <div className="card-body mt-4 p-0">
                  <span className="mb-1">Flat</span>
                  <h4 className="mb-1">13%</h4>
                  <h6 className="fw-normal">On Domestic Flights</h6>
                  <div className="d-flex justify-content-between align-items-center mt-4">
                    <div className="bg-primary bg-opacity-10 border border-2 border-primary border-dashed rounded-2 px-3 py-2">
                      <h5 className="fw-normal user-select-all mb-0">13PO7FF</h5>
                    </div>
                    <a aria-current="page" href="#!" className="router-link-active router-link-exact-active btn btn-lg btn-white btn-round mb-0">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="mb-1">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="card bg-info bg-opacity-10 h-100 p-4">
                <img src="images/09-CVtSHR3A.svg" className="w-75" alt="" />
                <div className="card-body mt-4 p-0">
                  <span className="mb-1">Flat</span>
                  <h4 className="mb-1">$2,400</h4>
                  <h6 className="fw-normal">On International Flights</h6>
                  <div className="d-flex justify-content-between align-items-center mt-4">
                    <div className="bg-primary bg-opacity-10 border border-2 border-primary border-dashed rounded-2 px-3 py-2">
                      <h5 className="fw-normal user-select-all mb-0">LOG165F</h5>
                    </div>
                    <a aria-current="page" href="#!" className="router-link-active router-link-exact-active btn btn-lg btn-white btn-round mb-0">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="mb-1">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Popular Destinations</h4>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              <div className="destination">
                <Box className="eximg-group g-bg-4">
                  <img className="" src='images/thailand.jpg' alt='' />
                </Box>
                <div className='py-2'>
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title">
                      <a href="#!">Thailand</a>
                    </h5>
                    <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                  </div>
                  <span className="mb-0">The next flight is on 26th Dec</span>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4">
                  <img className="" src='images/thailand.jpg' alt='' />
                </Box>
                <div className='py-2'>
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title">
                      <a href="#!">Thailand</a>
                    </h5>
                    <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                  </div>
                  <span className="mb-0">The next flight is on 26th Dec</span>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4">
                  <img className="" src='images/thailand.jpg' alt='' />
                </Box>
                <div className='py-2'>
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title">
                      <a href="#!">Thailand</a>
                    </h5>
                    <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                  </div>
                  <span className="mb-0">The next flight is on 26th Dec</span>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4">
                  <img className="" src='images/thailand.jpg' alt='' />
                </Box>
                <div className='py-2'>
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title">
                      <a href="#!">Thailand</a>
                    </h5>
                    <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                  </div>
                  <span className="mb-0">The next flight is on 26th Dec</span>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4">
                  <img className="" src='images/thailand.jpg' alt='' />
                </Box>
                <div className='py-2'>
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title">
                      <a href="#!">Thailand</a>
                    </h5>
                    <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                  </div>
                  <span className="mb-0">The next flight is on 26th Dec</span>
                </div>
              </div>
            </Carousel>
          </div>
        </div>
      </section>
      <section className='specialOffers'>
        <div className='container'>
          <div className="row g-4 g-lg-5 justify-content-center stepSec">
            <div className="col-sm-6 col-md-4 text-center position-relative">
              <i className="fa-solid fa-arrow-trend-down"></i>
              <div className="px-5">
                <img src="images/step-3.svg" className="w-150px mb-3" alt="" />
                <h5>Search Choice</h5>
                <p className="mb-0">Total's 630 + destinations that we work with</p>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 position-relative text-center pt-0 pt-lg-5">
              <i className="fa-solid fa-arrow-trend-up"></i>
              <div className="px-5">
                <img src="images/step-2.svg" className="w-150px mb-3" alt="" />
                <h5>Select Destination</h5>
                <p className="mb-0">Insipidity the sufficient discretion imprudence</p>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 text-center">
              <div className="px-5">
                <img src="images/step-1.svg" className="w-150px mb-3" alt="" />
                <h5>Easy to Book</h5>
                <p className="mb-0">With an easy and fast ticket purchase process</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='specialOffers'>
        <div className='container'>
          <div className="bg-light rounded-3 position-relative p-4 p-sm-5">
            <div className="row align-items-center position-relative dicoverSec">
              <div className="col-lg-8">
                <div className="d-flex">
                  <h3>It's time to discover</h3>
                  <img src="images/04-DrYI6v5l.svg" className="h-40px ms-3" alt="" />
                </div>
                <p className="mb-3 mb-lg-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.  </p>
              </div>
              <div className="col-lg-4 text-lg-end"><Link to="/signRegister" className="btn btn-lg btn-dark mb-0">Book a Flight</Link></div>
            </div>
          </div>
        </div>
      </section>
      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Latest Blogs & News</h4>
            </div>
          </div>
          <div className="row g-4 g-xl-5 justify-content-between blogs">
            <div className="col-md-6">
              <div className="card bg-transparent">
                <img src="images/01-MhAPPZx6.jpg" className="card-img" alt="" />
                <div className="card-body px-3">
                  <h4>
                    <a href="#!">10 Ways on How to Improve your Hotel Operations </a>
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-md-6 cardSec">
              <div className="card bg-transparent mb-4 mb-md-5">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <img src="images/02-eN-TCkPc.jpg" className="card-img" alt="" />
                  </div>
                  <div className="col-sm-8">
                    <div className="card-body p-sm-0">
                      <h5 className="card-title">
                        <a href="#!">Story of water world adventure</a>
                      </h5>
                      <p className="mb-0">Jacqueline Miller</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card bg-transparent mb-4 mb-md-5">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <img src="images/03-CsrralM0.jpg" className="card-img" alt="" />
                  </div>
                  <div className="col-sm-8">
                    <div className="card-body p-sm-0">
                      <h5 className="card-title">
                        <a href="#!">How Hotel Technology Can Help Small Hotel Businesses</a>
                      </h5>
                      <p className="mb-0">Frances Guerrero</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card bg-transparent mb-4 mb-md-5">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <img src="images/04-BUUYY-AN.jpg" className="card-img" alt="" />
                  </div>
                  <div className="col-sm-8">
                    <div className="card-body p-sm-0">
                      <h5 className="card-title">
                        <a href="#!">Hotel Service - Become a Guide for Your Guests</a>
                      </h5>
                      <p className="mb-0">Louis Ferguson</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <ToastContainer />
      <Footer />
    </>
  )
}

export default Home

const classes = [
  { label: 'Economy', value: 'Economy' },
  { label: 'Business', value: 'Business' },
  { label: 'First', value: 'First' },
  { label: 'Premium Economy', value: 'Premium Economy' },
  { label: 'Premium Business', value: 'Premium Business' },
  { label: 'Premium First', value: 'Premium First' },

];
const types = [
  { label: 'Economy', value: 'Economy' },
  { label: 'Bussiness', value: 'Bussiness' },

];
const flightTypes = [
  { label: 'Direct', value: 'Direct' },
  { label: 'Connecting', value: 'Connecting' },


];
// const from = [
//   { label: 'Delhi', value: 'Delhi' },
//   { label: 'Mumbai', value: 'Mumbai' },

// ];

// const to = [
//   { label: 'Agra', value: 'Agra' },
//   { label: 'Palwal', value: 'Palwal' },

// ];